import styled from 'styled-components';

export const TextBlockContainer = styled.div`
  display: grid;
  row-gap: 0.5em;
  align-self: center;
  grid-area: home-content;
  padding-top: 3rem;

    & > p {
        padding-right: 3em;
        line-height: 1.2;
        @media all and (max-width: 950px) {
          padding-right: 0px;
        }
    }

    & > h1 {
      line-height: 1.14;
    }

    @media all and (max-width: 800px) {
      justify-self: center;
      h1, p {
        text-align: center;
      }
      #_ratings{
        display: none;
      }
    }

`

export const TextBlockLinkContainer = styled.div`
    display: grid;
    column-gap: 2.1em;
    margin-bottom: 2rem;
    margin-top: 1.375rem;
    grid-template-columns: 240px 1fr;

    a {
      padding: 0.85em 0.5em;
    }
    
    @media all and (max-width: 1282px) {
        grid-template-columns: 240px 1fr;
        column-gap: 2em;
        button {
          justify-self: left;
          padding: 5px 0px;
        }
      }
    }

    @media all and (max-width: 1000px) {
        grid-template-columns: 1fr;
        row-gap: 36px;
        max-width: 88%;
        margin-bottom: 0rem;

        button {
            justify-self: left;
            padding-left: 0px;
          }
        }
        
    @media all and (max-width: 950px) {
      max-width: 100%;
      button {
        justify-self: center;
      }

      a {
        justify-self: center;
        width: 256px;
      }
    }

    @media all and (max-width: 800px) {
      a {
        span {
          text-align: center;
        }
      }
    }

    @media all and (max-width: 760px) {
      button {
        justify-self: center;
      }
    }
  }
`;
